import * as Onboarding_en from './Onboarding.en.js';
import * as Onboarding_es from './Onboarding.es.js';

const OnboardingTuple = [
  { type: 'Onboarding', language: 'en', object: Onboarding_en.default },
  { type: 'Onboarding', language: 'es', object: Onboarding_es.default },
];

export default OnboardingTuple;
